/*
 *
 * @desc: 专业级老用户升级折扣计划，Pro(1) -> Pro2(6),Titan(10); Pro2(6) -> Titan(10)
 * @author: haifn
 * @time: 2020/10/15 15:50
 *
 */

function getProductsConfig({ LANG }) {
  return {
    10: {
      id: 10,
      state: 0,
      key: 'titan',
      enable: true,
      btn: LANG['activity.202010ProfessionalDiscount.pageDescBtnTitan'],
      desc: LANG['activity.202010ProfessionalDiscount.pageDescTitan'],
      descSuccess: LANG['activity.202010ProfessionalDiscount.pageDescSuccessTitan'],
      descModalTips: LANG['activity.202010ProfessionalDiscount.modalTipsTitan'],
    },
    6: {
      id: 6,
      state: 0, // 0:可验证序列号，9:序列号验证成功
      key: 'pro2',
      enable: true,
      btn: LANG['activity.202010ProfessionalDiscount.pageDescBtnPro2'],
      desc: LANG['activity.202010ProfessionalDiscount.pageDescPro2'],
      descSuccess: LANG['activity.202010ProfessionalDiscount.pageDescSuccessPro2'],
      descModalTips: LANG['activity.202010ProfessionalDiscount.modalTipsPro2'],
    },
  };
}

function getProduct({ LANG, pid }) {
  return getProductsConfig({ LANG })[pid];
}

function getProductList({ LANG }) {
  const productsConfig = getProductsConfig({ LANG });
  const list = [];

  Object.keys(productsConfig).forEach((key) => list.push(productsConfig[key]));
  return list;
}

function isEnableProduct({ LANG, pid }) {
  const productsConfig = getProductsConfig({ LANG });
  return productsConfig[pid] && productsConfig[pid]['enable'];
}

export default {
  isEnableProduct,
  getProductList,
  getProduct,
};
